import Camera from '@components/graphics/Camera';
import Design from '@components/graphics/Design';
import Makers from '@components/graphics/Makers';
import RealEstate from '@components/graphics/RealEstate';

export interface TeamMemberProps {
    name: string;
    title: string;
    image: string;
    description?: string;
  }

export const teamMembers: TeamMemberProps[] = [
  {
    name: 'Alex Ryden',
    title: 'Founder & CEO',
    image: '/team/alex.jpg',
  },
  {
    name: 'Meghan Nally',
    title: 'Head of Operations',
    image: '/team/meghan.jpg'
  },
  {
    name: 'Ashleigh Stumler',
    title: 'Sales Director',
    image: '/team/ashleigh.jpg'
  },
  {
    name: 'Adam Sherry',
    title: 'Advisor',
    image: '/team/adam.jpeg'
  },
];

export const graphics = [
  {
    Svg: RealEstate,
    title: 'Real Estate Agents',
    description: 'We stage homes for realtors, homeowners and developers.'
  },
  {
    Svg: Camera,
    title: 'Photographers',
    description: 'Our team of photographers capture every property we bring to life.'
  },
  {
    Svg: Design,
    title: 'Interior Designers',
    description: 'Each project is lead by one of our talented interior designers.'
  },
  {
    Svg: Makers,
    title: 'Makers & Brands',
    description: 'We source goods from woodworkers, artists and companies we love.'
  },
];
